import { c as _c } from "react/compiler-runtime";
import { SALES_SETTINGS_API } from 'modules/funnels/api/sale-settings-api';
import { SaleSettingsViewInterface } from 'modules/funnels/types/sale-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useSaleSettings(id) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id || $[2] !== user) {
    t1 = () => {
      if (user && id) {
        return `${SALES_SETTINGS_API}/${id}`;
      }
      return null;
    };
    $[1] = id;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: saleSettings,
    mutate: mutateSaleSettings
  } = useSWR(t1, fetcher);
  let t2;
  if ($[4] !== mutateSaleSettings || $[5] !== saleSettings) {
    t2 = {
      saleSettings,
      mutateSaleSettings
    };
    $[4] = mutateSaleSettings;
    $[5] = saleSettings;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}